import React from "react";

import Tippy from '@tippyjs/react';
import moment from "moment";
import { map } from "lodash";

const headers = ['Nombre Ejecutivo', 'Rol', 'Actividad', 'Fecha Actividad'];

const NewActivityComponent = ({ activities, hidden }) => {

  return (
    <div className="crm-history-container crm-activity-container" hidden={hidden}>
      <div className="crm-history-table-container">
        {activities.length > 0 &&
          <table>
            <thead>
              <tr>
                {map(headers, (e, index) => (<th key={`thead-${index}`}>{e}</th>))}
              </tr>
            </thead>
            <tbody>
              {map(activities, (e, index) => (
                <tr key={`tbody-${index}`}>
                  <td>{`${e.executive.firstName} ${e.executive.lastName}`}</td>
                  <td>{e.executive.jobPosition}</td>
                  <Tippy
                    content={e.description}
                    disabled={e.description.length <= 14}
                    placement='bottom'
                  >
                    <td>{e.description.length <= 14 ? e.description : `${e.description.slice(0, 13)}...`}</td>
                  </Tippy>
                  <td>{moment(e.date).format('DD-MM-YYYY')}</td>
                </tr>
              )).reverse()}
            </tbody>
          </table>
        }
        {activities.loading &&
          <div className="crm-gestion-empty">Obteniendo Actividades...</div>
        }
        {!activities.loading && activities.length === 0 &&
          <div className="crm-gestion-empty">Aún no hay Actividades</div>
        }
      </div>
    </div >
  )
};

export default NewActivityComponent;